import { ResponsiveBar } from "@nivo/bar";
import { Box } from "@chakra-ui/react";

function CarbonValuesChart() {
  const COST_TYPES = Object.freeze({
    LOW_COST: "Low cost",
    AVERAGE_COST: "Average cost",
    HIGH_COST: "High cost"
  });
  const VALUES_COLORS = Object.freeze({
    [COST_TYPES.LOW_COST]: "hsl(213, 80%, 36%)",
    [COST_TYPES.AVERAGE_COST]: "hsl(208, 59%, 69%)",
    [COST_TYPES.HIGH_COST]: "hsl(226, 86%, 22%)"
  });

  const data = [
    {
      "year": 2020,
      "Low cost": 120,
      "Average cost": 241,
      "High cost": 361
    },
    {
      "year": 2021,
      "Low cost": 122,
      "Average cost": 245,
      "High cost": 367
    },
    {
      "year": 2022,
      "Low cost": 124,
      "Average cost": 248,
      "High cost": 373
    },
    {
      "year": 2023,
      "Low cost": 126,
      "Average cost": 252,
      "High cost": 378
    },
    {
      "year": 2024,
      "Low cost": 128,
      "Average cost": 256,
      "High cost": 384
    },
    {
      "year": 2025,
      "Low cost": 130,
      "Average cost": 260,
      "High cost": 390
    },
    {
      "year": 2026,
      "Low cost": 132,
      "Average cost": 264,
      "High cost": 396
    },
    {
      "year": 2027,
      "Low cost": 134,
      "Average cost": 268,
      "High cost": 402
    },
    {
      "year": 2028,
      "Low cost": 136,
      "Average cost": 272,
      "High cost": 408
    },
    {
      "year": 2029,
      "Low cost": 138,
      "Average cost": 276,
      "High cost": 414
    },
    {
      "year": 2030,
      "Low cost": 140,
      "Average cost": 280,
      "High cost": 420
    },
    {
      "year": 2031,
      "Low cost": 142,
      "Average cost": 285,
      "High cost": 427
    },
    {
      "year": 2032,
      "Low cost": 144,
      "Average cost": 289,
      "High cost": 433
    },
    {
      "year": 2033,
      "Low cost": 147,
      "Average cost": 293,
      "High cost": 440
    },
    {
      "year": 2034,
      "Low cost": 149,
      "Average cost": 298,
      "High cost": 447
    },
    {
      "year": 2035,
      "Low cost": 151,
      "Average cost": 302,
      "High cost": 453
    },
    {
      "year": 2036,
      "Low cost": 153,
      "Average cost": 307,
      "High cost": 460
    },
    {
      "year": 2037,
      "Low cost": 156,
      "Average cost": 312,
      "High cost": 467
    },
    {
      "year": 2038,
      "Low cost": 158,
      "Average cost": 316,
      "High cost": 474
    },
    {
      "year": 2039,
      "Low cost": 161,
      "Average cost": 321,
      "High cost": 482
    },
    {
      "year": 2040,
      "Low cost": 163,
      "Average cost": 326,
      "High cost": 489
    },
    {
      "year": 2041,
      "Low cost": 165,
      "Average cost": 331,
      "High cost": 496
    },
    {
      "year": 2042,
      "Low cost": 168,
      "Average cost": 336,
      "High cost": 504
    },
    {
      "year": 2043,
      "Low cost": 170,
      "Average cost": 341,
      "High cost": 511
    },
    {
      "year": 2044,
      "Low cost": 173,
      "Average cost": 346,
      "High cost": 519
    },
    {
      "year": 2045,
      "Low cost": 176,
      "Average cost": 351,
      "High cost": 527
    },
    {
      "year": 2046,
      "Low cost": 178,
      "Average cost": 356,
      "High cost": 535
    },
    {
      "year": 2047,
      "Low cost": 181,
      "Average cost": 362,
      "High cost": 543
    },
    {
      "year": 2048,
      "Low cost": 184,
      "Average cost": 367,
      "High cost": 551
    },
    {
      "year": 2049,
      "Low cost": 186,
      "Average cost": 373,
      "High cost": 559
    },
    {
      "year": 2050,
      "Low cost": 189,
      "Average cost": 378,
      "High cost": 568
    }
  ];

  return (
    <Box height={500} minWidth={800}>
      <ResponsiveBar
        data={data}
        keys={[
          COST_TYPES.LOW_COST,
          COST_TYPES.AVERAGE_COST,
          COST_TYPES.HIGH_COST
        ]}
        indexBy="year"
        margin={{ top: 20, right: 50, bottom: 90, left: 60 }}
        padding={0.3}
        groupMode="grouped"
        valueScale={{ type: "linear" }}
        indexScale={{ type: "band", round: true }}
        colors={item => VALUES_COLORS[item.id]}
        borderColor={{
          from: "color",
          modifiers: [
            [
              "darker",
              1.6
            ]
          ]
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: -45,
          legend:"Year",
          legendPosition: "middle",
          legendOffset: 40
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legendPosition: "middle",
          legend:"Carbon values in £",
          legendOffset: -40
        }}
        valueFormat={value => {return "£" + value}}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{
          from: "color",
          modifiers: [
            [
              "darker",
              1.6
            ]
          ]
        }}
        legends={[
          {
            dataFrom: "keys",
            anchor: "bottom",
            direction: "row",
            justify: false,
            translateX: 27,
            translateY: 70,
            itemsSpacing: 31,
            itemWidth: 76,
            itemHeight: 19,
            itemDirection: "left-to-right",
            itemOpacity: 0.85,
            symbolSize: 15,
            effects: [
              {
                on: "hover",
                style: {
                  itemOpacity: 1
                }
              }
            ]
          }
        ]}
        role="application"
        ariaLabel="Carbon price chart"
      />
    </Box>
  );
}

export default CarbonValuesChart;